import { SUPPORTED_LOCALES, DEFAULT_LOCALE, type SupportedLocale } from '@/i18n'

export const ROUTES = {
  home: '',
  news: 'news',
  newsPost: (slug: string) => `news/${slug}`,
  privacy: 'privacy',
  terms: 'terms',
} as const

export function localePath(locale: SupportedLocale, path: string): string {
  if (locale === DEFAULT_LOCALE) return path === '' ? '/' : `/${path}`
  return path === '' ? `/${locale}` : `/${locale}/${path}`
}

export function extractLocaleFromPath(pathname: string): {
  locale: SupportedLocale
  rest: string
} {
  const segments = pathname.split('/').filter(Boolean)
  const candidate = segments[0] as SupportedLocale | undefined
  if (candidate && (SUPPORTED_LOCALES as readonly string[]).includes(candidate)) {
    return { locale: candidate, rest: '/' + segments.slice(1).join('/') }
  }
  return { locale: DEFAULT_LOCALE, rest: pathname }
}
